<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          เปลี่ยนรหัสผ่าน
          <v-spacer></v-spacer>
          <v-btn icon class="float-right" @click="dialog = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-0">
          <v-row justify="center" align="center" class="mt-5">
            <v-col justify="center" align="center">
              <v-container fluid>
                <v-card>
                  <v-row justify="center" align="center" class="mt-4">
                    <h5 class="mt-4">** กรุณากรอก Password ใหม่ **</h5>
                  </v-row>
                  <v-card-text>
                    <v-form ref="form">
                      <v-row align="center" justify="center">
                        <v-col cols="12">
                          <v-text-field
                            v-model="password"
                            label="รหัสผ่าน"
                            type="password"
                            :rules="oldpasswordRules"
                            outlined
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field
                            v-model="new_password"
                            label="รหัสผ่านใหม่"
                            type="password"
                            :rules="passwordRules"
                            outlined
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field
                            v-model="confirm_password"
                            label="ยืนยันรหัสผ่าน"
                            type="password"
                            outlined
                            :rules="cfpasswordRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-col> </v-row
        ></v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="show_loading"
            text
            @click="resetPassword()"
            >บันทึก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      show_loading: false,
      password: "",
      new_password: "",
      confirm_password: "",
      oldpasswordRules: [
        (v) => !!v || "* กรุณากรอกรหัสผ่านเดิม",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      passwordRules: [
        (v) => !!v || "* กรุณากรอกรหัสผ่าน",
        (v) => v.length >= 4 || "* รหัสผ่านควรมีความยาวอย่างน้อย 4 ตัว",
        (v) =>
          /^([A-Za-z0-9])+$/.test(v) ||
          "* กรุณาใส่รหัสผ่านเป็นภาษาอังกฤษหรือตัวเลข",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      cfpasswordRules: [
        (v) => !!v || "* กรุณายืนยันรหัสผ่าน",
        (v) => v == this.new_password || "* รหัสผ่านไม่ตรงกัน",
      ],
      header_token: {
        headers: { Authorization: "Bearer " + this.$session.get("token") },
      },
    };
  },
  methods: {
    openDialogResetPassword() {
      // console.log(this.$session.getAll());
      this.password = "";
      this.new_password = "";
      this.confirm_password = "";
      setTimeout(() => {
        // this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }, 100);
      this.dialog = true;
    },
    resetPassword() {
      if (this.$refs.form.validate()) {
        this.show_loading = true;
        // console.log("putttttttttttt");
        let data = {
          password: this.password,
          new_password: this.new_password,
          confirm_password: this.confirm_password,
        };
        this.axios
          .put(
            process.env.VUE_APP_API + "/api/v1/password",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data);
            if (response.data.message === "success") {
              this.$swal.fire(
                "เปลี่ยนรหัสผ่านสำเร็จ",
                "กรุณาทำการเข้าสู่ระบบ",
                "success"
              );
              this.show_loading = false;
              this.dialog = false;
              this.password = "";
              this.new_password = "";
              this.confirm_password = "";
              this.$session.clear();
              window.location.pathname == "/home"
                ? this.$vuetify.goTo(0)
                : this.$router.push("/home");
              window.location.reload();
            } else if (response.data.message == "Unauthorized") {
              this.$swal.fire("ไม่สำเร็จ", "รหัสผ่านเดิมไม่ถูกต้อง ", "error");
              this.show_loading = false;
            }
          })
          .catch((err) => {
            this.$swal.fire({
              icon: "error",
              width: 500,
              title: "เกิดข้อผิดพลาด",
              text: "กรุณาลองใหม่อีกครั้ง",
              showConfirmButton: false,
              timer: 2000,
              showCloseButton: true,
            });
            this.show_loading = false;
          });
      } else {
        this.$swal.fire(
          "กรุณากรอกรหัสผ่านใหม่",
          "รหัสทั้งสองช่องไม่ตรงกัน",
          "warning"
        );
      }
    },
  },
};
</script>